var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
/**
 * @hidden
 */
var GroupStickyHeader = /** @class */ (function (_super) {
    __extends(GroupStickyHeader, _super);
    function GroupStickyHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GroupStickyHeader.prototype.render = function () {
        var _a = this.props, group = _a.group, groupMode = _a.groupMode, renderer = _a.render;
        var item = (React.createElement("div", { className: "k-list-group-sticky-header" }, groupMode === 'classic'
            ? group
            : React.createElement("div", { className: "k-list-header-text" }, group)));
        return renderer !== undefined ? renderer.call(undefined, item, this.props) : item;
    };
    return GroupStickyHeader;
}(React.Component));
export default GroupStickyHeader;
